import { render } from "./SampleEdit.vue?vue&type=template&id=1a2cc771&scoped=true"
import script from "./SampleEdit.vue?vue&type=script&lang=js"
export * from "./SampleEdit.vue?vue&type=script&lang=js"

import "./SampleEdit.vue?vue&type=style&index=0&id=1a2cc771&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2cc771"]])

export default __exports__